package com.example.monetix.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Boolean
import kotlin.Long
import kotlin.String

public class RecurringExpenseQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> all(mapper: (
    id: String,
    name: String,
    type: String,
    amountCents: Long,
    accountId: String,
    toAccountId: String?,
    categoryId: String,
    dayOfMonth: Long,
    isEnabled: Boolean,
    isDeleted: Boolean,
    cycleTarget: Long?,
    logoEmoji: String?,
    logoUri: String?,
    notes: String?,
    autoGenerateOnReminder: Boolean,
    nextEpochDay: Long,
    frequency: String?,
    isPaused: Boolean,
    startEpochDay: Long,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) -> T): Query<T> = Query(1_331_057_873, arrayOf("RecurringExpenseEntity"), driver,
      "RecurringExpense.sq", "all",
      "SELECT RecurringExpenseEntity.id, RecurringExpenseEntity.name, RecurringExpenseEntity.type, RecurringExpenseEntity.amountCents, RecurringExpenseEntity.accountId, RecurringExpenseEntity.toAccountId, RecurringExpenseEntity.categoryId, RecurringExpenseEntity.dayOfMonth, RecurringExpenseEntity.isEnabled, RecurringExpenseEntity.isDeleted, RecurringExpenseEntity.cycleTarget, RecurringExpenseEntity.logoEmoji, RecurringExpenseEntity.logoUri, RecurringExpenseEntity.notes, RecurringExpenseEntity.autoGenerateOnReminder, RecurringExpenseEntity.nextEpochDay, RecurringExpenseEntity.frequency, RecurringExpenseEntity.isPaused, RecurringExpenseEntity.startEpochDay, RecurringExpenseEntity.createdAtEpochMs, RecurringExpenseEntity.updatedAtEpochMs FROM RecurringExpenseEntity WHERE isDeleted = 0") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getString(1)!!,
      cursor.getString(2)!!,
      cursor.getLong(3)!!,
      cursor.getString(4)!!,
      cursor.getString(5),
      cursor.getString(6)!!,
      cursor.getLong(7)!!,
      cursor.getBoolean(8)!!,
      cursor.getBoolean(9)!!,
      cursor.getLong(10),
      cursor.getString(11),
      cursor.getString(12),
      cursor.getString(13),
      cursor.getBoolean(14)!!,
      cursor.getLong(15)!!,
      cursor.getString(16),
      cursor.getBoolean(17)!!,
      cursor.getLong(18)!!,
      cursor.getLong(19)!!,
      cursor.getLong(20)!!
    )
  }

  public fun all(): Query<RecurringExpenseEntity> = all { id, name, type, amountCents, accountId,
      toAccountId, categoryId, dayOfMonth, isEnabled, isDeleted, cycleTarget, logoEmoji, logoUri,
      notes, autoGenerateOnReminder, nextEpochDay, frequency, isPaused, startEpochDay,
      createdAtEpochMs, updatedAtEpochMs ->
    RecurringExpenseEntity(
      id,
      name,
      type,
      amountCents,
      accountId,
      toAccountId,
      categoryId,
      dayOfMonth,
      isEnabled,
      isDeleted,
      cycleTarget,
      logoEmoji,
      logoUri,
      notes,
      autoGenerateOnReminder,
      nextEpochDay,
      frequency,
      isPaused,
      startEpochDay,
      createdAtEpochMs,
      updatedAtEpochMs
    )
  }

  public suspend fun upsert(
    id: String,
    name: String,
    type: String,
    amountCents: Long,
    accountId: String,
    toAccountId: String?,
    categoryId: String,
    dayOfMonth: Long,
    isEnabled: Boolean,
    isDeleted: Boolean,
    cycleTarget: Long?,
    logoEmoji: String?,
    logoUri: String?,
    notes: String?,
    autoGenerateOnReminder: Boolean,
    nextEpochDay: Long,
    frequency: String?,
    isPaused: Boolean,
    startEpochDay: Long,
    createdAtEpochMs: Long,
    updatedAtEpochMs: Long,
  ) {
    driver.execute(-1_311_363_073,
        """INSERT OR REPLACE INTO RecurringExpenseEntity VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)""",
        21) {
          bindString(0, id)
          bindString(1, name)
          bindString(2, type)
          bindLong(3, amountCents)
          bindString(4, accountId)
          bindString(5, toAccountId)
          bindString(6, categoryId)
          bindLong(7, dayOfMonth)
          bindBoolean(8, isEnabled)
          bindBoolean(9, isDeleted)
          bindLong(10, cycleTarget)
          bindString(11, logoEmoji)
          bindString(12, logoUri)
          bindString(13, notes)
          bindBoolean(14, autoGenerateOnReminder)
          bindLong(15, nextEpochDay)
          bindString(16, frequency)
          bindBoolean(17, isPaused)
          bindLong(18, startEpochDay)
          bindLong(19, createdAtEpochMs)
          bindLong(20, updatedAtEpochMs)
        }.await()
    notifyQueries(-1_311_363_073) { emit ->
      emit("RecurringExpenseEntity")
    }
  }

  public suspend fun softDelete(updatedAtEpochMs: Long, id: String) {
    driver.execute(-2_109_256_379,
        """UPDATE RecurringExpenseEntity SET isDeleted = 1, updatedAtEpochMs = ? WHERE id = ?""", 2)
        {
          bindLong(0, updatedAtEpochMs)
          bindString(1, id)
        }.await()
    notifyQueries(-2_109_256_379) { emit ->
      emit("RecurringExpenseEntity")
    }
  }

  public suspend fun setEnabled(
    isEnabled: Boolean,
    updatedAtEpochMs: Long,
    id: String,
  ) {
    driver.execute(-149_601_457,
        """UPDATE RecurringExpenseEntity SET isEnabled = ?, updatedAtEpochMs = ? WHERE id = ?""", 3)
        {
          bindBoolean(0, isEnabled)
          bindLong(1, updatedAtEpochMs)
          bindString(2, id)
        }.await()
    notifyQueries(-149_601_457) { emit ->
      emit("RecurringExpenseEntity")
    }
  }
}
